/**
 * ClinicMonthlyTrendsStrip — the 3-chart strip on a clinic location tab
 * (iter 277). Pulls from GET /api/clinic-trends?clinic=<name>&months=13.
 * Skips ghost months (backend already filters). Trend line is 3-month
 * rolling average and excludes the current month.
 */
import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import MonthlyTrendChart from '../MonthlyTrendChart';

export default function ClinicMonthlyTrendsStrip({ clinicName }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!clinicName) return;
    api.get('/clinic-trends', { params: { clinic: clinicName, months: 13 } })
      .then((r) => setData(r.data))
      .catch(() => setData({ months: [] }));
  }, [clinicName]);
  if (!data) return null;
  const months = (data.months || []).map((m) => ({ ...m }));

  return (
    <div data-testid={`clinic-trends-strip-${(clinicName || '').replace(/\W+/g, '_')}`}>
      <MonthlyTrendChart
        title="Monthly Sessions"
        subtitle="Shows + Late Cancels + No-Shows · 13-month view"
        data={months.map((m) => ({ ...m, value: m.sessions_total }))}
        color="#685B72"
        format="num"
        testid="clinic-trend-sessions"
      />
    </div>
  );
}
